import { AbstractControl } from '@angular/forms';

export function getClassToinput(control: AbstractControl) {
    if (!control) { return; }
    if (!control.pristine && control.invalid) {
        return 'is-invalid';
    }
    if (!control.pristine && control.valid) {
        return 'is-valid';
    }
}

export function toChunk(chunkSize: number, array: any[]): any[] {
    return [].concat.apply([],
        array.map(function (elem, i) {
            return i % chunkSize ? [] : [array.slice(i, i + chunkSize)];
        })
    );
}

export function isInteger(value: any): value is number {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
}
export function isCorreiosShipping(order: any): boolean {
    if (!order) return false;

    const correiosNames = ['correios', 'pac', 'sedex'];

    if (order.invoice &&
        order.invoice.invoice &&
        order.invoice.invoice.carrier &&
        order.invoice.invoice.carrier.name) {

        const carrierName = order.invoice.invoice.carrier.name.toLowerCase();
        if (correiosNames.some(name => carrierName.includes(name))) {
            return true;
        }
    }

    if (order.transportCompany &&
        order.transportCompany.name) {

        const companyName = order.transportCompany.name.toLowerCase();
        return correiosNames.some(name => companyName.includes(name));
    }

    return false;
}